import {ModelContext} from '../../types/app.types';
import {ConvertedMoney} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class PriceModel {
  public convertedAmount: number;
  public formattedConvertedAmount: string;

  constructor(params: PriceModel) {
    this.convertedAmount = params.convertedAmount;
    this.formattedConvertedAmount = params.formattedConvertedAmount;
  }

  public static fromCartV1(
    multiCurrencyPrice: {convertedAmount?: string; formattedConvertedAmount?: string},
    modelContext: ModelContext
  ) {
    return new PriceModel({
      convertedAmount: parseFloat(multiCurrencyPrice?.convertedAmount),
      formattedConvertedAmount: modelContext.formatAmount(multiCurrencyPrice?.convertedAmount),
    });
  }

  public static fromCartV2(price: ConvertedMoney, modelContext: ModelContext): PriceModel {
    return new PriceModel({
      convertedAmount: parseFloat(price?.convertedAmount),
      formattedConvertedAmount: modelContext.formatAmount(price?.convertedAmount),
    });
  }
}
